import { render, staticRenderFns } from "./RTMPComponent.vue?vue&type=template&id=19324aa1"
import script from "./RTMPComponent.vue?vue&type=script&lang=js"
export * from "./RTMPComponent.vue?vue&type=script&lang=js"
import style0 from "./RTMPComponent.vue?vue&type=style&index=0&id=19324aa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports